import { render, staticRenderFns } from "./ProfileAccountComponent.vue?vue&type=template&id=c8c880ac&scoped=true"
import script from "./ProfileAccountComponent.vue?vue&type=script&lang=js"
export * from "./ProfileAccountComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfileAccountComponent.vue?vue&type=style&index=0&id=c8c880ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c880ac",
  null
  
)

export default component.exports